import { t } from '@lingui/macro';
import { I18n } from '@lingui/core';

function getMeanWindowOptions(i18n : I18n) {
  return [
    {
      label: t(i18n)`Dato bruto`,
      window: null,
    },
    {
      label: t(i18n)`1 minuto`,
      window: '1m',
    },
    {
      label: t(i18n)`5 minutos`,
      window: '5m',
    },
    {
      label: t(i18n)`10 minutos`,
      window: '10m',
    },
    {
      label: t(i18n)`15 minutos`,
      window: '15m',
    },
    {
      label: t(i18n)`30 minutos`,
      window: '30m',
    },
    {
      label: t(i18n)`1 hora`,
      window: '1h',
    },
    {
      label: t(i18n)`6 horas`,
      window: '6h',
    },
    {
      label: t(i18n)`12 horas`,
      window: '12h',
    },
    {
      label: t(i18n)`1 día`,
      window: '1d',
    },
    {
      label: t(i18n)`3 días`,
      window: '3d',
    },
  ];
}

export { getMeanWindowOptions };
